import React from 'react';
import TransactionsTable from '../../components/transactions/tables/transactions-table';
// import Invoice from '../../components/base/invoice';

const Transactions = () => {
  return (
    <div>
      <TransactionsTable />

      {/* <Invoice /> */}
    </div>
  );
};

export default Transactions;
